import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import messages from '../../locale/messages';
import validateStep3 from './validateStep3';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import updateStep3 from './updateStep3';
import stepCalendarIllustration from '/public/SiteImages/step-calendar.svg';

import s from './ListPlaceStep1.css';

class MinMaxNights extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number.isRequired,
    listingSteps: PropTypes.shape({
      step3: PropTypes.string.isRequired,
      listing: PropTypes.shape({
        isPublished: PropTypes.bool.isRequired
      })
    }),
  };

  static defaultProps = {
    minNightData: 0,
    maxNightData: 0,
    listingSteps: {
      step3: "inactive",
      listing: {
        isPublished: false
      }
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      minNight: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      maxNight: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      isDisabled: false,
    }
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;

    if (listingFields != undefined) {
      this.setState({
        minNight: listingFields.minNight[0],
        maxNight: listingFields.maxNight[0],
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;

    if (listingFields != undefined) {
      this.setState({
        minNight: listingFields.minNight[0],
        maxNight: listingFields.maxNight[0],
      });
    }
  }

  renderCounter = ({ input: { value, onChange }, minValue = 1, maxValue = 1000, incrementBy = 1 }) => {
    const val = value !== undefined && value !== null && value !== '' ? Number(value) : minValue;
    const isDisableDecrement = val <= minValue;
    const isDisableIncrement = val >= maxValue;

    const handleDecrement = (e) => {
      e && e.preventDefault();
      if (!isDisableDecrement) {
        onChange(val - incrementBy);
      }
    };

    const handleIncrement = (e) => {
      e && e.preventDefault();
      if (!isDisableIncrement) {
        onChange(val + incrementBy);
      }
    };

    return (
      <div className={s.minMaxCounterWrapper}>
        <div className={s.minMaxCapsule}>
          <button
            type="button"
            className={cx(s.minMaxCapsuleBtn, { [s.minMaxCapsuleBtnDisabled]: isDisableDecrement })}
            onClick={handleDecrement}
            disabled={isDisableDecrement}
          >
            <svg width="12" height="2" viewBox="0 0 12 2" fill="none">
              <rect width="12" height="2" rx="1" fill="currentColor" />
            </svg>
          </button>
          <span className={s.minMaxCapsuleValue}>{val}</span>
          <button
            type="button"
            className={cx(s.minMaxCapsuleBtn, { [s.minMaxCapsuleBtnDisabled]: isDisableIncrement })}
            onClick={handleIncrement}
            disabled={isDisableIncrement}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M6 1V11M1 6H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <span className={s.minMaxUnitLabel}>Noches</span>
      </div>
    );
  };

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step } = this.props;
    const { minNight, maxNight } = this.state;
    const { minNightData, maxNightData, existingList } = this.props;
    let isDisabled = false;
    if (maxNightData > 0) {
      if (minNightData > maxNightData) {
        isDisabled = true;
      }
    }
    let path = "index";
    if (existingList) {
      path = "home";
    }

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            mainTitle={
              <>
                ¿Tiene una cantidad de noches{' '}
                <span className={s.sidePanelHighlight}>mínimas o máximas</span>
                {' '}que puede reservar un huésped?
              </>
            }
            subtitle="Si agregas estas restricciones, podrás obtener reservas que se adapten mejor a tus preferencias"
            iconImg={stepCalendarIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={cx(s.stepRightCard, s.minMaxStepCard)}>
              <div className={s.landingMainContent}>
                {/* Estancia mínima */}
                <div className={s.minMaxSection}>
                  <div className={s.minMaxHeaderRow}>
                    <div className={s.minMaxHeaderIcon}>
                      <svg width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="#0F172A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                      </svg>
                    </div>
                    <div className={s.minMaxHeaderText}>
                      <h2 className={s.minMaxSectionTitle}>Estancia mínima</h2>
                      <p className={s.minMaxSectionSubtitle}>
                        Establece el número mínimo de noches que debe reservar un huésped.
                      </p>
                      <Field
                        name="minNight"
                        type="text"
                        component={this.renderCounter}
                        maxValue={minNight.endValue || 1000}
                        minValue={minNight.startValue || 1}
                        incrementBy={1}
                      />

                      {isDisabled && <div className={s.errorMessage}> <FormattedMessage {...messages.tripLengthError1} /> </div>}

                      <label className={s.minMaxCheckboxRow}>
                        <input type="checkbox" className={s.minMaxCheckboxInput} />
                        <span className={s.minMaxCheckboxLabel}>No establecer un mínimo</span>
                      </label>
                    </div>
                  </div>


                </div>

                <hr className={s.minMaxDivider} />

                {/* Estancia máxima */}
                <div className={s.minMaxSection}>
                  <div className={s.minMaxHeaderRow}>
                    <div className={s.minMaxHeaderIcon}>
                      <svg width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="#0F172A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="5" />
                        <line x1="12" y1="1" x2="12" y2="3" />
                        <line x1="12" y1="21" x2="12" y2="23" />
                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                        <line x1="1" y1="12" x2="3" y2="12" />
                        <line x1="21" y1="12" x2="23" y2="12" />
                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                      </svg>
                    </div>
                    <div className={s.minMaxHeaderText}>
                      <h2 className={s.minMaxSectionTitle}>Estancia máxima</h2>
                      <p className={s.minMaxSectionSubtitle}>
                        Establece el número máximo de noches que puede reservar un huésped.
                      </p>
                      <Field
                        name="maxNight"
                        type="text"
                        component={this.renderCounter}
                        maxValue={maxNight.endValue || 1000}
                        minValue={maxNight.startValue || 1}
                        incrementBy={1}
                      />

                      <label className={s.minMaxCheckboxRow}>
                        <input type="checkbox" className={s.minMaxCheckboxInput} />
                        <span className={s.minMaxCheckboxLabel}>No establecer un máximo</span>
                      </label>
                    </div>
                  </div>


                </div>
              </div>

              <FooterButton
                nextPage={nextPage}
                previousPage={previousPage}
                nextPagePath={"pricing"}
                previousPagePath={"description"}
                formPage={formPage}
                step={step}
                isDisabled={isDisabled}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep3'); // <-- same as form name

MinMaxNights = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(MinMaxNights);

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  minNightData: selector(state, 'minNight'),
  maxNightData: selector(state, 'maxNight'),
  listingSteps: state.location.listingSteps,
  existingList: state.location.isExistingList
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(MinMaxNights)));